import React, { useEffect, useRef } from "react";
import "react-phone-number-input/style.css";
import styles from "./styles/phone-input.module.scss";
import PhoneInput from "react-phone-number-input";
import { FiArrowDownRight } from "react-icons/fi";
import { StateContext } from "context/context";

interface Props {
    number: any | undefined;
    setNumber: React.Dispatch<React.SetStateAction<any>>;
}

const HigherPhoneInput = ({ number, setNumber }: Props) => {

    const inputRef = useRef<any>(null);
    /**
    * Validate e164 format
    */

    const { state: { privacyPermission } } = StateContext();

    const handleChange = (e: string) => {
        setNumber(e || "");
    };

    useEffect(() => {
        if (privacyPermission) {
            inputRef?.current.focus();
        }
    }, [privacyPermission]);

    // to fix zoom add this in for some reason
    //  maximum-scale=1
    return (
        <div className={styles.input}>
            {number && number.length <= 0 &&
                <div className={styles.arrow}>
                    <FiArrowDownRight />
                </div>
            }
            <PhoneInput
                ref={inputRef}
                defaultCountry="US"
                placeholder="Enter Phone Number"
                value={number}
                onChange={handleChange}
            />
            <span className={styles.border}></span>
        </div>
    );

};

export default HigherPhoneInput;
